/**
 * useRoleListForPreview — GET /api/eraf/roles 전체 목록 (preview simulator 전용).
 *
 * #472: MenuPreviewDrawer 의 역할 선택자를 하드코딩에서 DB 실제 역할 목록으로 교체.
 * role-management 내부를 import 하지 않고 menuApi 의 axios client 를 재사용한다.
 *
 * queryKey: ['menu-management', 'roles-for-preview']
 * staleTime: 5분 (역할 목록은 드물게 변경)
 */
import { useQuery } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';

export function useRoleListForPreview() {
  return useQuery({
    queryKey: ['menu-management', 'roles-for-preview'],
    queryFn: () => menuApi.getRoles(),
    staleTime: 5 * 60 * 1000,
  });
}
